/***********************************************
* RenderHtml.js
* 
* Show a HTML file
***********************************************/
/* Layout files */
import '../assets/style/RenderMarkdown.css';

/* Global imports */
import React                                   from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { withTranslation }                     from 'react-i18next';

/* Allow this component to navigate to different pages */
function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (<Component {...props} router={{ location, navigate, params }} />);
    }
  
    return ComponentWithRouterProp;
}

class RenderHtml extends React.Component {
    constructor(props) {
        super(props);
        this.state = { html: '' };

        fetch(props.htmlFile).then(res => res.text()).then(text => this.setState({ html: text }));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.htmlFile !== this.props.htmlFile) {
            fetch(this.props.htmlFile).then(res => res.text()).then(text => this.setState({ html: text }));
        }
    }

    render() {
        const navigate = this.props.router.navigate;
        const { html } = this.state;

        return (
            <div className="fullMarkdownPage">
                <div className="loginMarkdownDiv">
                    <select name="language" id="language" className="languageSelect" value={this.props.language.active} onChange={(e) => this.props.language.set(e.target.value)}>
                        {this.props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                    </select>
                    <div onClick={() => navigate("/")} className="button bigButton">{this.props.t("home")}</div>
                </div>
                <div dangerouslySetInnerHTML={{ __html: html }} className={this.props.className} />
            </div>
        );
    }
}

export default withTranslation("Misc")(withRouter(RenderHtml));